import {
  pullcheck
} from '@/api/business/searchList'
import {sockedlist} from '@/api/pubrequst'
import api from "@/api";

export default {
  namespaced: true,
  state: {
    url:{
     to:"",
     form:""
    },
    title:"首页",
    pulldatas: {}, //关于故障的一些值分类
    menuSlide:"max",
    versionmsg:"",
    sockedlist:[]
  },
  actions: {
    async SET_SCOK_DATA({commit}){
      sockedlist()
      .then(({data})=>{
      
        commit("setsockedlist",data)
      })
    },
    async GET_PULL_DATA({
      commit
    }) {
      let data
        let datas= await pullcheck({})
        if(datas.data){
          data=datas.data
        }else{
          return 
        }
        commit("getpulldata", data)
        return new Promise((res,rej)=>{
          res(data)
        })
    },
    SET_URL({commit},data){
      commit("seturl", data)
    },
    SET_TITLE({commit},data){
      commit("settitle", data)
    },
    async SET_VERSION({commit}){
      api.axss("get", `/ocm-oil-site/oil-site-publish-version/newest/record`).then((data)=>{
        commit("setversion", data.data)
      })
    }
  },
  mutations: {
    setsockedlist(state,data){
      state.sockedlist=data
    },
    setversion(state,data){
      state.versionmsg=data
     
    },
    setmenuSlide(state,data){
      state.menuSlide=data
    },
    settitle(state,data){
      state.title = data
    },
    getpulldata(state, data) {
      state.pulldatas = data
    },
    seturl(state, data){
     
       state.url=data
    }
  }
}